import Icon from '@/components/Icon/Icon';
import Menu, { MenuItem } from '@/components/Menu/';
import { renderChildren } from '@/components/Menu/MenuUtil';
import { noop, stopEvent, getWindowSize } from '@/utils/util';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Animate from 'rc-animate';
import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './Dropdown.scss';

const MouseEvents = ['mousedown', 'mousemove', 'mouseup'];
const winSize = getWindowSize();
class Dropdown extends Component {
  static propTypes = {
    showMenu: PropTypes.bool, // 控制menu的显影
  };
  static defaultProps = {
    autoAlign: true,
    onItemClick: noop,
    onMenuVisibleChange: noop, // menu visible change,
    sortable: false, // 如果父元素是sortable的，需要设置为true
  }
  constructor(props) {
    super(props);
    this.setShowMenu(props.showMenu);
    this.state = {
      showMenu: false,
    };
  }
  componentDidMount() {
    const { sortable } = this.props;
    if (sortable) {
      this.stopEventsForSortableParent(true);
    }
    this.autoAlignMenu();
    window.addEventListener('click', this.clickInside, false);
  }

  componentWillReceiveProps(nextProps) {
    // 如果外侧设置了
    this.setShowMenu(nextProps.showMenu);
  }
  componentDidUpdate() {
    this.autoAlignMenu();
  }
  componentWillUnmount() {
    window.removeEventListener('click', this.clickInside, false);
    this.stopEventsForSortableParent(false);
  }
  autoAlignMenu = () => {
    const { autoAlign } = this.props;
    // 计算下显示的位置是否合理
    if (autoAlign && this.menuRef) {
      const rect = this.menuRef.getBoundingClientRect();
      if (rect.width && rect.height) {
        let { className } = this.menuRef;
        if ((rect.height + rect.top) > winSize[1]) {
          className = className.replace(new RegExp(styles['menu-bottom']), '');
          this.menuRef.className = `${className} ${styles['menu-top']}`;
        }
      }
    }
  }
  stopPropagationEvent = (e) => {
    e.stopPropagation();
  }
  // 对于sortable元素需要取消一些事件，以保证排序动作流畅
  // 因为react的事件系统会导致事件最后触发，无法在父元素事件触发之前就阻止掉冒泡，所以用原生的监听方式
  stopEventsForSortableParent = (on) => {
    if (on) {
      MouseEvents.map((v) => {
        this.dropDown.addEventListener(v, this.stopPropagationEvent, false);
        return null;
      });
    } else {
      MouseEvents.map((v) => {
        this.dropDown.removeEventListener(v, this.stopPropagationEvent, false);
        return null;
      });
    }
  }
  setShowMenu = (visible, isMenuClick) => {
    const { onMenuVisibleChange } = this.props;
    if (typeof visible === 'boolean') {
      // onMenuVisibleChange(visible);
      this.setState({
        showMenu: visible,
      });
    }
  }
  iconClickHandler = (e) => {
    const { showMenu } = this.state;
    this.setShowMenu(!showMenu);
  };

  clickInside = (e) => {
    // 如果点击到外部，则进行switch
    const isClickInside = this.dropDown.contains(e.target);
    if (!isClickInside) {
      this.setShowMenu(false);
    }
  }

  renderDropIcon = () => {
    const { children } = this.props;
    if (children) {
      return renderChildren(children, {
        onClick: this.iconClickHandler,
      });
    }
    return (<Icon name='gear' className={styles['icon-gear']} onClick={this.iconClickHandler}/>);
  }
  onDropDownItemClick = (e, data) => {
    const { onItemClick } = this.props;
    onItemClick(e, data);
  }
  renderDropDownMenu = () => {
    const { showMenu } = this.state;
    const { menuItems, menuCustomClass, autoFix } = this.props;
    let menuClass = [menuCustomClass, styles['menu'], styles['menu-bottom']];
    menuClass = classNames(menuClass, {
      [styles['show']]: showMenu,
    });

    return (
      <Menu
        getMenuDom={(v) => {
          this.menuRef = v;
        }}
        className={menuClass}
        onClick={this.onDropDownItemClick}
      >
        {menuItems}
      </Menu>
    );
  }
  render() {
    const { showMenu } = this.state;
    const { children, className } = this.props;
    const cls = classNames(styles['dropdown'], className);
    return (
      <div
        className={cls}
        ref={(el) => {
          this.dropDown = el;
        }}
      >
        { this.renderDropIcon() }
        <Animate transitionName='fade' component='span'>
          { this.renderDropDownMenu()}
        </Animate>
      </div>
    );
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/Dropdown/Dropdown.js